<template>
  <div>
    <div style="width: 894px;" class="container accord24">
      <h1 class="title">CERTIFICATE OF PROPERTY INSURANCE</h1>
      <table id="piece">
        <tr>
          <td>
            DATE (MM/DD/YYYY)
          </td>
        </tr>
        <tr>
          <td>
            {{currentDate}}
          </td>
        </tr>
      </table>
      <table style="font-size:8px;font-weight:bold;margin-top:-10px">
        <tr>
          <td colspan="12" class="content1">
            THIS CERTIFICATE IS ISSUED AS A MATTER OF INFOMATION ONLY AND CONFERS NO RIGHTS UPON THE CERTIFICATE HOLDER. THIS CERTIFICATE
            DOES NOT AFFIRMATIVELY OR NEGATIVELY AMEND, EXTEND OR ALTER THE COVERAGE AFFORDED BY THE POLICIES BELOW. THIS
            CERTIFICATE OF INSURANCE DOES NOT CONSTITUTE A CONSTRACT VETWEEN THE ISSUING INSURER(S), AUTHORIZED REPRESENTATIVE
            OR PRODUCER, AND THE CERTIFICATE HOLDER.
          </td>
        </tr>

        <tr>
          <td rowspan="5" colspan="6" width="50%">
            PRODUCER
            <textarea v-if="!readonly" type="text" colspan="6" class="lg-textarea" v-model="accord24.Producer"></textarea>
            <div style="min-height: 100px" class="pdf-input" v-if="readonly" v-html="translateTextarea(accord24.Producer)"> </div>
          </td>
          <td colspan="6">
            CONTACT
            <br/>NAME:
            <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.ContactName">
            <span class="pdf-input" v-if="readonly"> {{accord24.ContactName}} </span>
          </td>
          <tr>
            <td colspan="3">
              PHONE
              <br/>(A/C,NO,Ext):
              <input v-if="!readonly" type="text" class="lg-60" v-model="accord24.PhoneNumber">
              <span class="pdf-input" v-if="readonly"> {{accord24.PhoneNumber}} </span>
            </td>
            <td colspan="3">
              FAX
              <br/>(A/C,No):
              <input v-if="!readonly" type="text" class="lg-40" v-model="accord24.FaxNumber">
              <span class="pdf-input" v-if="readonly"> {{accord24.FaxNumber}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              E-MAIL
              <br/>ADDRESS:
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.ContactEmailAddress">
              <span class="pdf-input" v-if="readonly"> {{accord24.ContactEmailAddress}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              PRODUCER
              <br/>CUSTOMER ID:
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.ProducerCustomerId">
              <span class="pdf-input" v-if="readonly"> {{accord24.ProducerCustomerId}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5" style="text-align:center">
              INSURER(S) AFFORDING COVERAGE
            </td>
            <td colspan="1" style="text-align:center">
              NAIC#
            </td>
          </tr>

          <tr>
            <td rowspan="6" colspan="6">
              INSURED
              <textarea v-if="!readonly" type="text" class="lg-textarea" v-model="accord24.Insured"></textarea>
              <div class="pdf-input" style="min-height: 100px;" v-if="readonly" v-html="translateTextarea(accord24.Insured)"></div>
            </td>
            <td colspan="5">
              INSURER A:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerA_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerA_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerA_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.FaxNumber}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              INSURER B:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerB_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerB_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerB_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerB_NAIC}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              INSURER C:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerC_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerC_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerC_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerC_NAIC}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              INSURER D:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerD_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerD_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerD_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerD_NAIC}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              INSURER E:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerE_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerE_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerE_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerE_NAIC}} </span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              INSURER F:
              <input v-if="!readonly" type="text" class="lg-70" v-model="accord24.InsurerF_Name">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerF_Name}} </span>
            </td>
            <td colspan="1">
              <input v-if="!readonly" type="text" class="lg-80" v-model="accord24.InsurerF_NAIC">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerF_NAIC}} </span>
            </td>
          </tr>
      </table>

      <table style="width:100%; border: none;" id="middle_part">
        <tr>
          <td width=" 30%" style="border: none;">
            COVERAGES
          </td>
          <td width="40%" style="border: none;">
            CERTIFICATE NUMBER:
            <input style="width: 95%;" v-if="!readonly" type="text" class="lg" v-model="accord24.CertificateNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.CertificateNumber}} </span>
          </td>
          <td width="40%" style="border: none;">
            REVISION NUMBER:
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.RevisionNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.RevisionNumber}} </span>
          </td>
        </tr>
      </table>

      <table>
        <tr>
          <td colspan="20" class="content3">
            LOCATION OF PREMISES/DESCRIPTION OF PROPERTY (Use Additional Remarks, if more space is required)
            <textarea v-if="!readonly" data-limit-rows="true" rows="4" type="text" class="lg md-textarea" v-model="accord24.PropertyDescription"></textarea>
            <div class="pdf-input" style="min-height: 100px;" v-if="readonly" v-html="translateTextarea(accord24.PropertyDescription)"></div>
          </td>
        </tr>

        <tr>
          <td colspan="20" class="content4">
            THIS IS TO CERTFY THAT TIE POLICIES OF INSURANCE LISTED BELOW HAVE BEEN ISSUED TO THE INSURED NAMED ABOVE FOR THE POLICY
            PERIOD INDICATED. NOTWITHSTANDING ANY REQUIREMENT, TERM OF CONDITION OF ANY CONTRACT OR OTHER DOCUMENT WITH RESPECT
            TO WHICH THIS CERTIFICATE MAY BE ISSUSED OR MAY PERTAIN, THE INSURANCE AFFORDED BY THE POLICIES DESCRIBED HEREIN
            IS SUBJECT TO ALL THE TERMS, EXCLUSIONS AND CONDITIONS OF SUCH POLICIES. LIMITS SHOWN MAY HAVE BEEN REDUCED BY
            PAID CLAIMS.
          </td>
        </tr>
        <!-- new line -->
        <tr class="content5">
          <th colspan="2">
            INSR
            <br/>LTR
          </th>
          <th colspan="4">
            TYPE OF INSURANCE
          </th>
          <th colspan="4">
            POLICY NUMBER
          </th>
          <th colspan="2">
            POLICY EFFECTIVE
            <br/>DATE(MM/DD/YYYY)
          </th>
          <th colspan="2">
            POLICYEXPIRATION
            <br/>DATE(MM/DD/YYYY)
          </th>
          <th colspan="3">
            COVERED PROPERTY
          </th>
          <th colspan="3">
            LIMITS
          </th>
        </tr>
        <!-- new line -->
        <tr>
          <td rowspan="11" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="sm1" v-model="accord24.InsurerLetter1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1}} </span>
          </td>
        </tr>

        <tr>
          <td rowspan="2" colspan="2" style="line-height: 17px;">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsProperty">
            <span class="span-checkbox" v-if="readonly"> {{translateCheckbox(accord24.InsurerLetter1_IsProperty)}} </span>
            <b>
              <label class="pro">PROPERTY</label>
            </b>
            <br/>
            <span style="margin-left:3px">CAUSES OF LOSS</span>
          </td>
          <td colspan="2" class="rmbt">
          </td>
          <td rowspan="10" colspan="4">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter1_PolicyNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_PolicyNumber}} </span>
          </td>
          <td rowspan="10" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter1_EffectiveDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_EffectiveDate}} </span>
          </td>
          <td rowspan="10" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter1_ExpirationDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_ExpirationDate}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBuilding">
            <span class="span-checkbox" v-if="readonly"> {{translateCheckbox(accord24.InsurerLetter1_IsBuilding)}} </span>
            <label class="con"> BUILDING</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_BuildingLimits">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BuildingLimits}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2" class="rmtop">
            DEDUCTIBLES
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsPersonalProperty">
            <span class="span-checkbox" v-if="readonly"> {{translateCheckbox(accord24.InsurerLetter1_IsPersonalProperty)}} </span>
            <label class="con"> PERSONAL PROPERTY</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_PersonalPropertyLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_PersonalPropertyLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBasic">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBasic) }} </span>
            <label class="con">BASIC</label>
          </td>
          <td rowspan="3" colspan="2">
            BUILDING
            <br>
            <input v-if="!readonly" type="text" style="height:15px;width:60px" v-model="accord24.InsurerLetter1_BuildingDeductible">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BuildingDeductible}} </span>
            <hr> CONTENTS
            <br>
            <input v-if="!readonly" type="text" style="height:15px;width:60px" v-model="accord24.InsurerLetter1_ContentsDeductible">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_ContentsDeductible}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBusinessIncome">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBusinessIncome) }} </span>
            <label class="con">BUSINESS INCOME</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_BusinessIncomeLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BusinessIncomeLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBroad">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBroad) }} </span>
            <label class="con"> BROAD</label>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsExtraExpense">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsExtraExpense) }} </span>
            <label class="con">EXTRA EXPENSE</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_ExtraExpenseLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_ExtraExpenseLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsSpecial">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsSpecial) }} </span>
            <label class="con"> SPECIAL</label>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsRentalValue">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsRentalValue) }} </span>
            <label class="con">RENTAL VALUE</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_RentalValueLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_RentalValueLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsEarthquake">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsEarthquake) }} </span>
            <label class="con"> EARTHQUAKE</label>
          </td>
          <td colspan="2">
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_EarthquakeDeductible">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_EarthquakeDeductible}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBlanketBuilding">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBlanketBuilding) }} </span>
            <label class="con">BLANKET BUILDING</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_BlanketBuildingLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BlanketBuildingLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsWind">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsWind) }} </span>
            <label class="con">WIND</label>
          </td>
          <td colspan="2">
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_WindDeductible">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_WindDeductible}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBlanketPersonalProperty">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBlanketPersonalProperty) }} </span>
            <label class="con">BLANKET PERS PROP</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_BlanketPersonalPropertyLimits">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BlanketPersonalPropertyLimits}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsFlood">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsFlood) }} </span>
            <label class="con"> FLOOD</label>
          </td>
          <td colspan="2">
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_FloodDeductible">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_FloodDeductible}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty) }} </span>
            <label class="con">BLANKET BLDG & PP</label>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsOtherInsurance1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsOtherInsurance1) }} </span>
            <input v-if="!readonly" type="text" style="width:60px;height:20px;padding-left:3px" v-model="accord24.InsurerLetter1_OtherInsurance1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherInsurance1}} </span>
          </td>
          <td colspan="2">
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_OtherDeductible1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherDeductible1}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsOtherProperty1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsOtherProperty1) }} </span>
            <input v-if="!readonly" type="text" style="width:100px;height:20px;padding-left:3px" v-model="accord24.InsurerLetter1_OtherProperty1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherProperty1}} </span>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_OtherPropertyLimit1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherPropertyLimit1}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsOtherInsurance2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsOtherInsurance2) }} </span>
            <input v-if="!readonly" type="text" style="width:60px;height:20px;padding-left:3px" v-model="accord24.InsurerLetter1_OtherInsurance2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherInsurance2}} </span>
          </td>
          <td colspan="2">
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_OtherDeductible2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherDeductible2}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter1_IsOtherProperty2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter1_IsOtherProperty2) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter1_OtherProperty2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherProperty2}} </span>
          </td>
          <td colspan="3">
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter1_OtherPropertyLimit2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter1_OtherPropertyLimit2}} </span>
          </td>
        </tr>

        <tr>
          <td rowspan="5" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="sm1" v-model="accord24.InsurerLetter2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2}} </span>
          </td>
        </tr>

        <tr>
          <td rowspan="2" colspan="4" style="border-bottom:none">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsInlandMarine">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsInlandMarine) }} </span>
            <b>
              <label class="pro"> INLAND MARINE</label>
            </b>
            <br/>
            <label class="con">CAUSES OF LOSS</label>
            <br/>
          </td>
          <td colspan="4" class="rmbt">
            TYPE OF POLICY
          </td>
          <td rowspan="4" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter2_EffectiveDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_EffectiveDate}} </span>
          </td>
          <td rowspan="4" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter2_ExpirationDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_ExpirationDate}} </span>
          </td>
          <td colspan="3" class="rmbottom">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsOtherProperty1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsOtherProperty1) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter2_OtherProperty1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherProperty1}} </span>
          </td>
          <td>$
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter2_OtherPropertyLimit1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherPropertyLimit1}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="4" class="rmtop">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter2_PolicyType">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_PolicyType}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsOtherProperty2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsOtherProperty2) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter2_OtherProperty2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherProperty2}} </span>
            <td>$
              <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter2_OtherPropertyLimit2">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherPropertyLimit2}} </span>
            </td>
        </tr>

        <tr>
          <td colspan="4" style="border:none">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsNamedPerils">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsNamedPerils) }} </span>
            <label class="con"> NAMED PERILS</label>
          </td>
          <td colspan="4" class="rmbt">
            POLICY NUMBER
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsOtherProperty3">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_IsOtherProperty3}} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter2_OtherProperty3">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherProperty3}} </span>
          </td>
          <td>$
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter2_OtherPropertyLimit3">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherPropertyLimit3}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="4" style="border-top:none">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsOtherInsurance4">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsOtherInsurance4) }} </span>
            <input v-if="!readonly" type="text" style="width:100px;height:20px;padding-left:3px" v-model="accord24.InsurerLetter2_OtherInsurance4">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherInsurance4}} </span>
          </td>
          <td colspan="4" class="rmtop">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter2_PolicyNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_PolicyNumber}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter2_IsOtherProperty4">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter2_IsOtherProperty4) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter2_OtherProperty4">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherProperty4}} </span>
          </td>
          <td>$
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter2_OtherPropertyLimit4">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter2_OtherPropertyLimit4}} </span>
          </td>
        </tr>

        <!-- new line -->
        <tr>
          <td rowspan="3" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="sm1" v-model="accord24.InsurerLetter3">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3}} </span>
          </td>
          <td rowspan="3" colspan="4">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter3_IsCrime">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter3_IsCrime) }} </span>
            <b>
              <label class="pro" style="line-height:31px"> CRIME
              </label>
              <br/>
            </b>
            <span class="spn">TYPE OF POLICY</span>
            <br/>
            <input v-if="!readonly" type="text" style="width:120px;height:20px;padding-left:3px" v-model="accord24.InsurerLetter3_PolicyType">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_PolicyType}} </span>
          </td>
          <td rowspan="3" colspan="4">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter3_PolicyNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_PolicyNumber}} </span>
          </td>
          <td rowspan="3" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter3_EffectiveDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_EffectiveDate}} </span>
          </td>
          <td rowspan="3" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter3_ExpirationDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_ExpirationDate}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter3_IsOtherProperty1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter3_IsOtherProperty1) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter3_OtherProperty1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherProperty1}} </span>
          </td>
          <td>
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter3_OtherPropertyLimit1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherPropertyLimit1}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter3_IsOtherProperty2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter3_IsOtherProperty2) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter3_OtherProperty2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherProperty2}} </span>
            <td>
              $
              <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter3_OtherPropertyLimit2">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherPropertyLimit2}} </span>
            </td>
        </tr>

        <tr>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter3_IsOtherProperty3">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter3_IsOtherProperty3) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter3_OtherProperty3">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherProperty3}} </span>
            <td>
              $
              <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter3_OtherPropertyLimit3">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter3_OtherPropertyLimit3}} </span>
            </td>
        </tr>
        <!-- new line   -->
        <tr>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="sm1" v-model="accord24.InsurerLetter4">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4}} </span>
          </td>
          <td rowspan="2" colspan="4">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter4_IsBoiler">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter4_IsBoiler) }} </span>
            <b>
              <label class="pro"> BOILER & MACHINERY /
                <br/> EQUIPMENT BREAKDOWN
              </label>
            </b>
          </td>
          <td rowspan="2" colspan="4">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter4_PolicyNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_PolicyNumber}} </span>
          </td>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter4_EffectiveDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_EffectiveDate}} </span>
          </td>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter4_ExpirationDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_ExpirationDate}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter4_IsOtherProperty1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter4_IsOtherProperty1) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter4_OtherProperty1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_OtherProperty1}} </span>
          </td>
          <td>
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter4_OtherPropertyLimit1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_OtherPropertyLimit1}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter4_IsOtherProperty2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter4_IsOtherProperty2) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter4_OtherProperty2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_OtherProperty2}} </span>
            <td>
              $
              <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter4_OtherPropertyLimit2">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter4_OtherPropertyLimit2}} </span>
            </td>
        </tr>
        <!-- new line  -->
        <tr>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="sm1" v-model="accord24.InsurerLetter5">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5}} </span>
          </td>
          <td rowspan="2" colspan="4">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter5_OtherInsurance1"></input>
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_OtherInsurance1}} </span>
          </td>
          <td rowspan="2" colspan="4">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter5_PolicyNumber">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_PolicyNumber}} </span>
          </td>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter5_EffectiveDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_EffectiveDate}} </span>
          </td>
          <td rowspan="2" colspan="2" class="textcenter">
            <input v-if="!readonly" type="text" class="lg" v-model="accord24.InsurerLetter5_ExpirationDate">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_ExpirationDate}} </span>
          </td>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter5_IsOtherProperty1">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter5_IsOtherProperty1) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter5_OtherProperty">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_OtherProperty}} </span>
          </td>
          <td>
            $
            <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter5_OtherPropertyLimit1">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_OtherPropertyLimit1}} </span>
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <input v-if="!readonly" type="checkbox" v-model="accord24.InsurerLetter5_IsOtherProperty2">
            <span class="span-checkbox" v-if="readonly"> {{ translateCheckbox(accord24.InsurerLetter5_IsOtherProperty2) }} </span>
            <input v-if="!readonly" type="text" class="txt1" v-model="accord24.InsurerLetter5_OtherProperty2">
            <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_OtherProperty2}} </span>
            <td>
              $
              <input v-if="!readonly" type="text" class="txt" v-model="accord24.InsurerLetter5_OtherPropertyLimit2">
              <span class="pdf-input" v-if="readonly"> {{accord24.InsurerLetter5_OtherPropertyLimit2}} </span>
            </td>
        </tr>
        <!-- new line -->
        <tr>
          <td rowspan="3" colspan="20">
            SPECIAL CONDITIONS/OTER CVERAGES (Use Additional Remarks, if more space is required)
            <textarea v-if="!readonly" type="text" class="lg-textarea" v-model="accord24.SpecialConditions"></textarea>
            <div class="pdf-input" style="min-height: 100px;" v-if="readonly" v-html="translateTextarea(accord24.SpecialConditions)">
            </div>
          </td>
        </tr>
      </table>

      <table style="width:100%; border: none;" id="middle_part2">
        <tr style="border: none;">
          <td style="border: none;">
            CERTIFICATE HOLDER
          </td>
          <td width="50%" style="border: none;">
            CANCELLATION
          </td>
        </tr>
      </table>

      <table style="width:100%">
        <tr>
          <td rowspan="5" style="width:50%" colspan="10">
            <textarea :disabled="!readonly && !requestViewer" placeholder="Certificate Holder will be filled at time of request" v-if="!readonly"
              type="text" v-model="accord24.CertificateHolder" class="lg-textarea"></textarea>
            <div class="pdf-input" v-if="readonly" style="min-height: 100px;" v-html="translateTextarea(accord24.CertificateHolder)"></div>
          </td>
          <td rowspan="3" style="width:50%" colspan="10" class="content6">
            SHOULD ANY OF THE ABOVE DESCRIBED POLICIES BE CANCELLED BEFORE
            </BR> THE EXPIRATION DATE THEREOF, NOTICE WILL BE DELIVERED IN
            </BR> ACCORDANCE WITH THE POLICY PROVISIONS.
          </td>
        </tr>
        <tr></tr>
        <tr></tr>
        <tr>
          <td rowspan="2" colspan="10">
            AUTHORIZED REPRESENTATIVE
            <input v-if="!readonly" type="text" class="md-textarea" v-model="accord24.AuthorizedRepresentative"></input>
            <span class="pdf-input" v-if="readonly"> {{accord24.AuthorizedRepresentative}} </span>
          </td>
        </tr>
      </table>
      <h1 class="title additional-remarks-header">ADDITIONAL REMARKS</h1>
      <table style="width:100%; margin-top: -10px;">
        <tr>
          <td rowspan="5" style="width:50%" colspan="10">
            <textarea class="remarks-textarea" placeholder="Use this section for additional remarks related to the policy and coverage"
              v-if="!readonly" type="text" v-model="accord24.AdditionalRemarks"></textarea>
            <div class="pdf-input" style="min-height: 1225px;" v-if="readonly" v-html="translateTextarea(accord24.AdditionalRemarks)"></div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Accord24',
    props: ['accord24', 'readonly', 'requestViewer'],
    data: function () {
      return {
        isLoading: false
      }
    },
    methods: {
      initialize(route) {
        // window.document.title = 'Preview'
        // this.fetchAssociation(route.params.id)
      },
      translateCheckbox(val) {
        if (val) {
          return 'X'
        }
        return ''
      },
      translateTextarea(val) {
        if (val) {
          return val.replace(/(?:\r\n|\r|\n)/g, '<br />')
        }
        return ''
      }
    },
    created: function () {
      this.initialize(this.$route)
    },
    computed: {
      currentDate() {
        return moment().format('MM/DD/YYYY')
      }
    }
  }

</script>

<style scoped>
  table {
    border-collapse: collapse;
  }

  table,
  td,
  th {
    border: 1px solid black;
    padding: 0px;
    font-size: 9px;
    margin: 3px 0px 3px 0px;
  }

  tr td .pro {
    vertical-align: middle;
    display: table-cell;
    padding-left: 3px;
    line-height: 24px;
  }

  tr td .con {
    float: left;
    padding-left: 3px;
    line-height: 20px;
  }

  tr td .spn {
    margin-left: 3px;
  }

  td {
    padding-left: 4px;
    padding-right: 4px;
  }

  hr {
    border: 0;
    height: 1px;
    background: #000000;
  }

  .rmbottom {
    border-bottom: none;
  }

  .rmtop {
    border-top: none;
  }

  .rmbt {
    border-bottom: none;
    border-top: none;
  }

  .sm {
    height: 10px;
    width: 80%;
  }

  .sm1 {
    height: 20px;
    width: 20px;
  }

  .lg {
    height: 20px;
    width: 100%;
  }

  .lg-textarea {
    height: 90px;
    width: 100%;
    resize: none;
  }

  .md-textarea {
    height: 40px;
    width: 100%;
    resize: none;
  }

  .lg-80 {
    height: 20px;
    width: 80%;
    margin-left: 20px;
  }

  .lg-70 {
    height: 20px;
    width: 70%;
  }

  .lg-60 {
    height: 20px;
    width: 60%;
  }

  .lg-40 {
    height: 20px;
    width: 40%;
  }

  .lg-30 {
    height: 20px;
    width: 30%;
  }

  tr td .txt {
    width: 60px;
    height: 20px;
    padding-left: 3px;
  }

  tr td .txt1 {
    width: 100px;
    height: 20px;
    padding-left: 3px;
  }

  div .daytag {
    border: 1px solid;
    width: 15%;
    text-align: center;
    border-bottom: none;
    font-size: 8px;
    margin-top: -30px;
    clear: both;
    float: right;
    margin-right: 3px;
  }

  .title {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
  }

  th {
    text-align: center;
  }

  textarea {
    background-color: #eff0ff;
    border: none;
    padding: 5px 5px 5px 5px;
    font-weight: 500;
  }

  textarea:disabled {
    background-color: lightgray !important;
  }

  input {
    border: none;
    border-color: transparent;
    font-size: 10px;
    background-color: #eff0ff;
    font-weight: 500;
  }

  input[type="checkbox"] {
    -webkit-appearance: initial;
    appearance: initial;
    width: 20px;
    height: 20px;
    border: none;
    background: ##eff0ff;
    position: relative;
    float: left;
    margin: 0px 0px 0px 0px;
  }

  input[type="checkbox"]:checked {
    background: #fffcfc;
    margin: 0px 0px 0px 0px;
  }

  input[type="checkbox"]:checked:after {
    /* Heres your symbol replacement - this is a tick in Unicode. */
    content: "\2715";
    color: #000000;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0px 0px 0px 0px;
  }

  div {
    font-size: 9px;
    font-weight: normal;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }

  .content1 {
    font-size: 11px;
    font-weight: bold;
    padding-left: 20px;
  }

  .content2 {
    margin-top: -18px;
  }

  .content3 {
    font-size: 9px;
    font-weight: bold;
  }

  .content4 {
    font-size: 11px;
    padding-left: 15px;
  }

  .content5 {
    font-size: 9px;
    font-weight: bold;
  }

  .content6 {
    padding: 5px 10px 10px 5px;
  }

  #middle_part td {
    font-weight: bold;
    border: none !important;
    font-size: 12px;
  }

  #middle_part2 td {
    font-weight: bold;
    border: none !important;
    font-size: 12px;
  }

  .textcenter {
    text-align: center;
  }

  #piece {
    position: absolute;
    float: right;
    top: 7px;
    right: 0px;
    text-align: center;
  }

  .span-checkbox {
    height: 15px;
    width: 15px;
    padding-top: 3px;
    float: left;
    text-align: center;
  }

  .additional-remarks-header {
    padding-top: 50px;
  }

  .remarks-textarea {
    height: 1225px;
    width: 100%;
    resize: none;
  }

  .pdf-input {
    font-weight: 700;
    font-size: 11.5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/associations/Accord24.vue?0a18fca8